<template>
  <div class="error">
    <div class="text2">
      <div v-if="showConfig">
        <div
          v-if="error.config"
          class="flex flex-col"
        >
          <span>please check this url</span>
          <span>{{ error.config.baseURL }} {{ error.config.url }}</span>
          <AppButton
            @click="copy(`${error.config.baseURL}${error.config.url}`)"
          >
            copy url
            <AppIcon
              color="text-white"
              name="information"
            />
          </AppButton>
        </div>
      </div>
    </div>
    <div
      v-if="error.statusCode === 404"
      class="error-404"
    >
      <div class="error__logo">
        <img
          data-src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
          class="lazyload"
        >
      </div>
      <div class="error__image">
        <img
          data-src="@images/error-blue-board.svg"
          :alt="$t('alt.logo_home_banner')"
          width="500"
          height="311"
          class="lazyload"
        >
        <div class="error__image__content-wrapper">
          <span class="error__image__content-wrapper__error-code">{{ $t("error_page.404.code") }}</span>
          <div class="error__image__content-wrapper__error-texts">
            <span class="text1">{{ $t("error_page.404.text.1") }}</span>
            <span
              v-if="error.message"
              class="text2"
            > {{ error.message }}</span>
          </div>
        </div>
      </div>
      <div class="error__button">
        <AppButton
          :text="$t('error_page.button')"
          color="primary"
          mode="fill"
          size="md"
          tag="a"
          :href="$routeName.home"
        />
      </div>
    </div>
    <div
      v-if="error.statusCode === 401"
      class="error-401"
    >
      <div class="error__logo">
        <img
          data-src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
          class="lazyload"
        >
      </div>
      <div class="error__image">
        <img
          data-src="@images/error-blue-board.svg"
          :alt="$t('alt.logo_home_banner')"
          width="500"
          height="311"
          class="lazyload"
        >
        <div class="error__image__content-wrapper">
          <span class="error__image__content-wrapper__error-code">{{ $t("error_page.401.code") }}</span>
          <div class="error__image__content-wrapper__error-texts">
            <span class="text1">{{ $t("error_page.401.text.1") }}</span>
            <span class="text2">{{ $t("error_page.401.text.2") }}</span>
            <span
              v-if="error.message"
              class="text2"
            > {{ error.message }}</span>
          </div>
        </div>
      </div>
      <div class="error__button">
        <AppButton
          :text="$t('forms.actions.join_app')"
          color="primary"
          mode="fill"
          size="md"
          tag="a"
          :href="$routeName.login"
        />
      </div>
    </div>
    <div
      v-if="error.statusCode === 500"
      class="error-500"
    >
      <div class="error__logo">
        <img
          data-src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
          class="lazyload"
        >
      </div>
      <div class="error__image">
        <img
          data-src="@images/error-blue-board.svg"
          :alt="$t('alt.logo_home_banner')"
          width="500"
          height="311"
          class="lazyload"
        >
        <div class="error__image__content-wrapper">
          <span class="error__image__content-wrapper__error-code">{{ $t("error_page.500.code") }}</span>
          <div class="error__image__content-wrapper__error-texts">
            <span class="text1"> {{ $t("error_page.500.text.1") }}</span>
            <span
              v-if="error.message"
              class="text2"
            > {{ error.message }}</span>
          </div>
        </div>
      </div>
      <div class="error__button">
        <AppButton
          :text="$t('error_page.button')"
          color="primary"
          mode="fill"
          size="md"
          tag="a"
          :href="$routeName.home"
        />
      </div>
    </div>
    <div
      v-if="error.statusCode === 503"
      class="error-503"
    >
      <div class="error__logo">
        <img
          data-src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
          class="lazyload"
        >
      </div>
      <div class="error__image">
        <img
          data-src="@images/error-blue-board.svg"
          :alt="$t('alt.logo_home_banner')"
          width="500"
          height="311"
          class="lazyload"
        >
        <div class="error__image__content-wrapper">
          <span class="error__image__content-wrapper__error-code">{{ $t("error_page.503.code") }}</span>
          <div class="error__image__content-wrapper__error-texts">
            <span class="text1"> {{ $t("error_page.503.text.1") }}</span>
          </div>
        </div>
      </div>
      <div class="error__button">
        <AppButton
          :text="$t('error_page.button')"
          color="primary"
          mode="fill"
          size="md"
          tag="a"
          :href="$routeName.home"
        />
      </div>
    </div>
    <div
      v-if="![404, 401, 500, 503].includes(error.statusCode)"
      class="error-500"
    >
      <div class="error__logo">
        <img
          data-src="/image/logo.png"
          :alt="$t('alt.logo_home_banner')"
          width="103"
          height="36"
          class="lazyload"
        >
      </div>
      <div class="error__image">
        <img
          data-src="@images/error-blue-board.svg"
          :alt="$t('alt.logo_home_banner')"
          width="500"
          height="311"
          class="lazyload"
        >
        <div class="error__image__content-wrapper">
          <span class="error__image__content-wrapper__error-code">{{ error.statusCode }}</span>
          <div class="error__image__content-wrapper__error-texts">
            <span class="text1">{{ error.message || $t("error_page.unknown_warning") }}</span>
          </div>
        </div>
      </div>
      <div class="error__button">
        <AppButton
          :text="$t('error_page.button')"
          color="primary"
          mode="fill"
          size="md"
          tag="a"
          :href="$routeName.home"
        />
      </div>
    </div>
  </div>
</template>

<script>
import clipboard from '@mixins/clipboard'

export default {
  name: 'LayoutsError',
  mixins: [clipboard],
  layout: 'auth',
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showConfig () {
      return this.$config.mode === 'development'
    }
  },
  mounted () {
    if (this.error && this.error.statusCode === 404) {
      this.$sentry.captureMessage(this.error.message, this.error)
    }
  }
}
</script>

<style lang="scss">
.error {
  > [class*="error-"] {
    @apply flex flex-col items-center px-4 md:px-0 py-24 md:py-52;
  }

  &__image {
    @apply relative mt-6 mb-12;
    &__content-wrapper {
      @apply flex flex-col text-center justify-center text-white;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      &__error {
        &-code {
          font-size: 26vw;
          line-height: 0.8;
          @apply font-bold;
          @screen md {
            @apply text-9xl;
            line-height: 0.8;
          }
        }

        &-texts {
          @apply flex flex-col md:text__main space-y-1;
          .text2 {
            @apply text__sub--3;
          }
        }
      }
    }
  }
}
</style>
